let ctx = null;

function getCtx() {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

/**
 * Resume audio context after user gesture (toggle on).
 */
export function resumeAudio() {
  const c = getCtx();
  if (c && c.state === 'suspended') {
    c.resume().catch(() => {});
  }
}

/**
 * @param {number} freq
 * @param {number} durationMs
 * @param {number} gain
 */
function beep(freq, durationMs, gain = 0.06) {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  g.gain.value = gain;
  const now = c.currentTime;
  g.gain.setValueAtTime(gain, now);
  g.gain.exponentialRampToValueAtTime(0.001, now + durationMs / 1000);
  osc.connect(g);
  g.connect(c.destination);
  osc.start(now);
  osc.stop(now + durationMs / 1000 + 0.02);
}

export function playMoveSound() {
  beep(520, 45, 0.05);
}

export function playWinSound() {
  beep(660, 70, 0.065);
  setTimeout(() => beep(880, 90, 0.055), 55);
}

export function playDrawSound() {
  beep(380, 100, 0.045);
}
